import React from "react";
import { createRoot } from "react-dom/client";

import Filters from "./react-components/pages/Filters";
import Library from "./react-components/pages/Library";
import Search from "./react-components/pages/Search";
import TransitieagendaContactpersonen from "./react-components/pages/Transitieagenda";
import OnderdeelContactpersonen from "./react-components/pages/Onderdeel";
import AgendaForm from "./react-components/pages/AgendaForm";
import ProjectCreateEdit from "./react-components/pages/ProjectCreateEdit";
import InspiratiepuntenDashboard from "./react-components/pages/InspiratiepuntenDashboard";
import InspiratiepuntenAdminDashboard from "./react-components/pages/InspiratiepuntenAdminDashboard";
import InspiratieViewList from "./react-components/pages/InspiratieViewList";
import InspiratiepuntenFilter from "./react-components/pages/InspiratiepuntenFilter";
import InspiratieFavourite from "./react-components/pages/InspiratieFavourite";

const listOfContainers = {
  "#actueel-react-container": <Filters />,
  "#agenda-react-container": <Filters />,
  "#deher-react-container": <Filters />,
  "#amini-react-container": <Filters />,
  "#wijkini-react-container": <Filters />,
  "#search-react-container": <Search />,
  "#transitiecontactpersonen-react-container": (
    <TransitieagendaContactpersonen />
  ),
  "#onderdeelcontactpersonen-react-container": <OnderdeelContactpersonen />,
  "#agenda-form-react-container": <AgendaForm />,
  "#project-create-edit-container": <ProjectCreateEdit />,
  "#inspiratiepunten-dashboard-container": <InspiratiepuntenDashboard />,
  "#inspiratiepunten-admin-dashboard-container": <InspiratiepuntenAdminDashboard />,
  "#inspiratiepunten-view-list": <InspiratieViewList />,
  "#inspiratiepunten-filter-container": <InspiratiepuntenFilter />,
  "#inspiratiepunten-favourite": <InspiratieFavourite />,
};

Object.keys(listOfContainers).forEach((containerName) => {
  const containerElements = document.querySelectorAll(containerName);

  if (containerElements.length > 0) {
    containerElements.forEach((containerElm) => {
      const dataAttributes = containerElm
        .getAttributeNames()
        .filter((attributeName) => attributeName.startsWith("data-"))
        .reduce((result, attributeName) => {
          const key = attributeName.slice(5); // Remove "data-" prefix
          const value = containerElm.getAttribute(attributeName);
          result[key] = value;
          return result;
        }, {});

      const component = listOfContainers[containerName];

      if (component) {
        // add data attributes as props to the component
        const props = { data: dataAttributes };
        listOfContainers[containerName] = React.cloneElement(component, props);
        // console.log(containerName, props);
      } else {
        console.warn(`Component not found for container "${containerName}"`);
      }

      // create a new root and render the component
      const rootElm = document.createElement("div");
      containerElm.appendChild(rootElm);
      const root = createRoot(rootElm);
      root.render(listOfContainers[containerName]);
    });
  }
});
